<template>
<div class="chapter">
<div class="inner_page">
      ﻿




<title>The Warlord’s Bride</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="dedicationPage" id="ded01"><p class="dedicationText"><span>For those who share my affection for men<br/>
with broadswords, with my thanks.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// warlordsbridethe_ded01.vue?2a4115aa